function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.4 14.9L27.4 12.4C27.2 12.2 27 12.1 26.7 12.1C26.4 12.1 26.2 12.2 26 12.4L23.9 14.9C23.7 15.2 23.6 15.5 23.8 15.8C24 16.1 24.3 16.3 24.6 16.3H25V19.7C25 20.2 25.4 20.6 25.9 20.6H27.5C28 20.6 28.4 20.2 28.4 19.7V16.3H28.8C29.1 16.3 29.4 16.1 29.6 15.8C29.7 15.5 29.6 15.1 29.4 14.9ZM27.5 15.4V19.7H25.9V15.4H24.7L26.7 12.9L28.8 15.4H27.5Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.30001 20.6C4.60001 20.6 4.80001 20.5 5.00001 20.3L7.10001 17.8C7.30001 17.5 7.40001 17.2 7.20001 16.9C7.00001 16.6 6.70001 16.4 6.40001 16.4H6.10001V13C6.10001 12.5 5.70001 12.1 5.20001 12.1H3.50001C3.00001 12.1 2.60001 12.5 2.60001 13V16.4H2.30001C2.00001 16.4 1.70001 16.6 1.50001 16.9C1.30001 17.2 1.40001 17.6 1.60001 17.8L3.70001 20.4C3.80001 20.5 4.10001 20.6 4.30001 20.6ZM3.50001 17.2V12.9H5.20001V17.2H6.40001L4.30001 19.7L2.20001 17.2H3.50001Z",
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.2 11.2H14.8C13.2 11.2 11.8 12.5 11.8 14.2V17C11.8 17.6 12.2 18.1 12.7 18.3V19.5V26.8C12.7 27.5 13.1 28 13.8 28.1C13.9 28.1 14 28.1 14.1 28.1C14.8 28.1 15.4 27.5 15.4 26.8V20C15.4 19.9 15.5 19.8 15.6 19.8C15.7 19.8 15.8 19.9 15.8 20V26.7C15.8 27.4 16.2 27.9 16.9 28C17 28 17.1 28 17.2 28C17.9 28 18.5 27.4 18.5 26.7V18.7V18.2C19 18 19.4 17.5 19.4 16.9V14.1C19.2 12.5 17.9 11.2 16.2 11.2ZM18.8 16.9C18.8 17.4 18.4 17.8 17.9 17.8V18.7V26.7C17.9 27.2 17.5 27.6 17 27.6C16.9 27.6 16.9 27.6 16.8 27.6C16.4 27.5 16.1 27.1 16.1 26.7V20C16.1 19.7 15.8 19.4 15.5 19.4C15.1 19.4 14.9 19.7 14.9 20V26.7C14.9 27.2 14.5 27.6 14 27.6C13.9 27.6 13.9 27.6 13.8 27.6C13.4 27.5 13.1 27.1 13.1 26.7V19.4V17.9C12.6 17.9 12.2 17.5 12.2 17V14.2C12.2 12.8 13.3 11.7 14.7 11.7H16.1C17.5 11.7 18.6 12.8 18.6 14.2V16.9H18.8Z",
  fill: "#1C33C8"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.5 10.9C16.6 10.9 17.6 10 17.6 8.80001C17.6 7.60001 16.7 6.70001 15.5 6.70001C14.3 6.70001 13.4 7.60001 13.4 8.80001C13.4 9.90001 14.4 10.9 15.5 10.9ZM15.5 7.10001C16.4 7.10001 17.1 7.80001 17.1 8.70001C17.1 9.60001 16.4 10.3 15.5 10.3C14.6 10.3 13.9 9.60001 13.9 8.70001C13.9 7.90001 14.6 7.10001 15.5 7.10001Z",
  fill: "#1C33C8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.4 28.6H23.2V2.7C23.2 2.1 22.7 1.5 22 1.5H9.00001C8.40001 1.5 7.80001 2 7.80001 2.7V28.5H3.60001C3.40001 28.5 3.20001 28.7 3.20001 28.9C3.20001 29.1 3.40001 29.3 3.60001 29.3H8.30001H22.9H27.6C27.8 29.3 28 29.1 28 28.9C27.9 28.8 27.7 28.6 27.4 28.6ZM8.70001 28.6V2.7C8.70001 2.5 8.80001 2.4 9.00001 2.4H22.1C22.3 2.4 22.4 2.5 22.4 2.7V28.5H8.70001V28.6Z",
  fill: "#1C33C8"
});

var SvgLift = function SvgLift(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLift, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lift.0c3a0071.svg";
export { ForwardRef as ReactComponent };